import { Component, Input } from '@angular/core';
import {
	NavController,
    NavParams, 
    ToastController} from 'ionic-angular';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ReportsService } from '../../../../services/reports.service';
import { ActionSheetController } from 'ionic-angular';
import { Winner } from '../../../../model/winner';
import { PayoutConfig } from '../../../../model/payoutConfig';
import { LeaderGenerator } from '../../../../lib/leaderGenerator';

@Component({
	selector: 'page-results-report',
	templateUrl: 'report-results.html'
	
})
export class ResultsReport {
    @Input('rodeo') rodeo: Rodeo;

    selectedRodeoEvent: RodeoEvent;
    allRodeoEvent: any;
    showContactInfo: boolean = false;

    winners: Winner[] = [];
    winnerTotals: number[] = [];
    winnerCategoryTotals: string[] = [];
    winnerPayouConfigMap: Map<number, number[]> = new Map();

    showAdvancedOptions: boolean;

    bankAccount: string;
    expenseAccount: string;
    expenseClass: string;

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    allLeaders: Map<number, any[]> = new Map();
    rodeoEventLeaders: any[] = [];

    winnersOnly: boolean;

    constructor(
        private nav: NavController, 
        navParams: NavParams, 
        private reportService: ReportsService, 
        public actionSheetCtrl: ActionSheetController,
        private toast: ToastController
    ) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.showContactInfo = navParams.get('showContactInfo');
        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        
        this.printing = navParams.get('printing');
        this.allRodeoEvent = { displayName: 'All', id: -1 };

        this.winnersOnly = navParams.get('winnersOnly');

        if (navParams.get('winners'))
            this.winners = navParams.get('winners');
        
        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.allLeaders = new Map();
        this.rodeoEventLeaders = [];

        if (this.rodeo && !this.printing)
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];

        this.allLeaders = LeaderGenerator.instance().getAllLeaders(this.rodeo, this.rodeo.payoutConfigs, true);

        this.rodeo.rodeoEvents.forEach(x => {
            this.setRodeoEventRuns(x);

            x.winners.forEach(winner => {
                if (!this.winnerPayouConfigMap.has(winner.payoutConfigId)) {
                    this.winnerPayouConfigMap.set(winner.payoutConfigId, []);
                }

                const mapItem = this.winnerPayouConfigMap.get(winner.payoutConfigId);
                mapItem.push(winner.id);
            })
        });

        this.updateRodeoEvent();

        this.documentTitle = this.rodeo.name + " - " + (this.selectedRodeoEvent ? this.selectedRodeoEvent.displayName : 'All') + ' Winners';
        this.dataLoaded = true;
    }

    setRodeoEventRuns(rodeoEvent: RodeoEvent) {
        const payoutConfigIds = new Set(rodeoEvent.winners.filter(x => x.payoutConfigId).map((winner) => winner.payoutConfigId));
        const payoutConfigIdArray = Array.from(payoutConfigIds);

        for (let j = 0; j < payoutConfigIdArray.length; j++) {
            const payoutConfigId = payoutConfigIdArray[j];
            const resultMode = this.rodeo.payoutConfigs.find(mode => mode.id == payoutConfigId);

            const payoutLeaders = this.allLeaders.get(payoutConfigId);

            if (payoutLeaders && payoutLeaders.length > 0) {
                this.setLeaders(rodeoEvent, payoutLeaders, resultMode);
            }
        }
    }

    setLeaders(rodeoEvent: RodeoEvent, leaders: any[], selectedMode: PayoutConfig) {
        var winnersToMatch = rodeoEvent.winners;
        var winnerGroups = [];

        leaders.forEach(group => {
            group.totalPayout = 0;

            group.runs.forEach((run, index) => {
                if (!run.winners)
                    run.winners = [];

                run.winners[selectedMode.id] = null;

                run.secondDisplayValue = this.getSecondDisplay(rodeoEvent, run);

                var matchingWinners = winnersToMatch.filter(x =>
                    (x.payoutConfigId == selectedMode.id)
                    && (x.name === group.name + ' - ' || x.name === group.name || x.name.includes(group.name) || group.name.includes(x.name)) // This breaks older results (2023) due to Winner name not matching group name for payoutConfigId
                    && (x.contestantOne ? x.contestantOne.id == run.contestantOneId : true)
                    && (x.contestantTwo ? x.contestantTwo.id == run.contestantTwoId : true)
                    && (x.horseOne ? x.horseOne.id == run.horseOneId : true)
                    && (x.horseTwo ? x.horseTwo.id == run.horseTwoId : true));

                if (selectedMode.name == 'Teams') {
                    matchingWinners = rodeoEvent.winners.filter(x =>
                        ((x.contestantOne ? x.contestantOne.id == run.contestantOneId : true)
                            || (run.contestantTwo ? x.contestantOne.id == run.contestantTwoId : true))
                        && ((x.horseOne ? x.horseOne.id == run.horseOneId : true)
                            || (run.horseTwo ? x.horseOne.id == run.horseTwoId : true)));
                }

                if (matchingWinners.length > 0) {
                    winnersToMatch = winnersToMatch.filter(x => x != matchingWinners[0]);

                    run.winners[selectedMode.id] = JSON.parse(JSON.stringify(matchingWinners[0]));

                    if (selectedMode.name == 'Teams') {
                        run.winners[selectedMode.id].payout *= 2;
                    }

                    group.totalPayout += run.winners[selectedMode.id].payout;
                }
            });

            if (group.runs.length > 0) {
                winnerGroups.push(group);
            }
        });

        if (!this.rodeoEventLeaders[rodeoEvent.id]) {
            this.rodeoEventLeaders[rodeoEvent.id] = [];
        }

        if (winnerGroups.length > 0) {
            this.rodeoEventLeaders[rodeoEvent.id].push(...winnerGroups);
            this.rodeoEventLeaders[rodeoEvent.id].sort((a, b) => {
                return a.mode.id - b.mode.id;
            });
        }
    }


    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    ionViewDidEnter() {
        if (this.printing) {
            setTimeout(() => {
                window.document.title = this.documentTitle;
                window.print();
                this.nav.pop(); 
            }, 0);
        }
    }

    updateRodeoEvent() {
        this.winnerCategoryTotals = [];

        if (this.selectedRodeoEvent && this.selectedRodeoEvent.id != -1) {
            this.winners = this.selectedRodeoEvent.winners;
            this.winnerTotals[this.selectedRodeoEvent.id] = this.winners.reduce((acc, winner) => { return acc + winner.payout; }, 0);
        } else {
            this.winners = this.rodeo.rodeoEvents.flatMap(x => x.winners);

            this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                this.winnerTotals[rodeoEvent.id] = rodeoEvent.winners.reduce((acc, winner) => { return acc + winner.payout; }, 0);
            })
        }

        this.winners.forEach((winner) => {
            this.winnerCategoryTotals[winner.name] = this.winners.filter(x => x.name == winner.name).reduce((acc, winner) => { return acc + winner.payout; }, 0);
        });

        this.winners.sort((a, b) => {
            if (!(a.isAggregate || a.isAverage) && (b.isAggregate || b.isAverage))
                return -1;
            else if ((a.isAggregate || a.isAverage) && !(b.isAggregate || b.isAverage))
                return 1;

            if (a.name < b.name)
                return -1;
            else if (a.name > b.name)
                return 1;

            /*
            if (a.round < b.round)
                return -1;
            else if (a.round > b.round)
                return 1;
*/
            if (a.place < b.place)
                return -1;
            else if (a.place > b.place)
                return 1;

            return 0;
        });

        console.log("sorted winners: ", this.winners);
    }

    isFirstWinnerPayoutConfigId(winner: Winner) {
        const payoutConfigWinners = this.winnerPayouConfigMap.get(winner.payoutConfigId);
        const isFirstPayoutConfigWinner = payoutConfigWinners.indexOf(winner.id) == 0;
        if (isFirstPayoutConfigWinner) {
            return true;
        } else {
            return false;
        }
    }

    getTotalCount(payoutConfigId: number) {
        var count = 0;

        const payoutConfig = this.rodeo.payoutConfigs.find(x => x.id == payoutConfigId);
        if (payoutConfig) {
            payoutConfig.sources.forEach((source) => {
                count += this.getSourceCount(payoutConfig, source);
            })
        }

        return count;
    }

    getSourceCount(payout: PayoutConfig, source) {        
        return LeaderGenerator.instance().getTotalCount(this.rodeo, payout, source, true);
    }

    async downloadEquistat(rodeoEvent: RodeoEvent) {
        if (rodeoEvent == this.allRodeoEvent) {
            await this.reportService.getEquistatReport(this.rodeo.name, this.rodeo.rodeoEvents.map(x => x.id), this.winnersOnly, true);
        } else {
            await this.reportService.getEquistatReport(rodeoEvent.displayName, [rodeoEvent.id], this.winnersOnly, true);
        }
    }

    printQuickBooksImport() {
        let winners = [];

        if (this.selectedRodeoEvent && this.selectedRodeoEvent.id != -1) {
            winners = this.selectedRodeoEvent.winners;
        } else {
            winners = this.rodeo.rodeoEvents.flatMap(x => x.winners);
        }
        
        const csvData =  [];
        const date = new Date().toLocaleDateString();
        winners.forEach(winner => {
            var payToName = `${winner.contestantOne.firstName} ${winner.contestantOne.lastName}`;
            var payToAddress = `${winner.contestantOne.streetAddress} ${winner.contestantOne.city}, ${winner.contestantOne.state} ${winner.contestantOne.zip}`;
            var payToFirstName = `${winner.contestantOne.firstName}`;
            var payToLastName = `${winner.contestantOne.lastName}`;
            var payToStreet = `${winner.contestantOne.streetAddress}`;
            var payToCity = `${winner.contestantOne.city}`;
            var payToState = `${winner.contestantOne.state}`;
            var payToZipCode = `${winner.contestantOne.zip}`;

            if (winner.payRiderOne == false && winner.horseOne != null && winner.horseOne.owner != null) {
                payToName = `${winner.horseOne.owner.name}`;
                payToAddress = `${winner.horseOne.owner.address} ${winner.horseOne.owner.city}, ${winner.horseOne.owner.state} ${winner.horseOne.owner.zip}`;
                payToFirstName = `${winner.horseOne.owner.name}`;
                payToLastName = ``;
                payToStreet = `${winner.horseOne.owner.address}`;
                payToCity = `${winner.horseOne.owner.city}`;
                payToState = `${winner.horseOne.owner.state}`;
                payToZipCode = `${winner.horseOne.owner.zip}`;
            }

            if (this.showContactInfo) {
                csvData.push({
                    REFNUMBER: 'To Print',
                    BANKACCOUNT: this.bankAccount,
                    VENDOR: payToName,
                    TXNDATE: date,
                    TOBEPRINTED: 'Y',
                    EXPENSEACCOUNT: this.expenseAccount,
                    EXPENSEAMOUNT: winner.payout,
                    EXPENSEDESCRIPTION: `${winner.name} - ${winner.place}: $${winner.payout}`,
                    'EXPENSE CLASS': this.expenseClass,
                    'Mailing Address line 1': payToAddress,
                    'First Name': payToFirstName,
                    'Last Name': payToLastName,
                    'Street Address': payToStreet,
                    'Last Street Address Line 2': ``,
                    'City': payToCity,
                    'State': payToState,
                    'Zip Code': payToZipCode,
                });
            } else {
                csvData.push({
                    REFNUMBER: 'To Print',
                    BANKACCOUNT: this.bankAccount,
                    VENDOR: payToName,
                    TXNDATE: date,
                    TOBEPRINTED: 'Y',
                    EXPENSEACCOUNT: this.expenseAccount,
                    EXPENSEAMOUNT: winner.payout,
                    EXPENSEDESCRIPTION: `${winner.name} - ${winner.place}: $${winner.payout}`,
                    'EXPENSE CLASS': this.expenseClass,
                });
            }

        });

        console.log({csvData});

        this.reportService.exportToCsv(csvData, `${this.rodeo.name} - ${this.selectedRodeoEvent ? this.selectedRodeoEvent.displayName : 'All'}`);
    }

    presentActionSheet() {
        const actionSheet = this.actionSheetCtrl.create({
            title: 'Select a report',
            buttons: [
                {
                    text: 'Results* (Compatible with Equistat)',
                    handler: () => {
                        if (this.selectedRodeoEvent) {
                            this.downloadEquistat(this.selectedRodeoEvent).then(() => {});
                        } else {
                            this.toast.create({message: 'You must select an event.', position: 'bottom', duration: 2500}).present();
                        }
                    }
                },{
                    text: 'QuickBooks Import',
                    handler: () => {
                        this.printQuickBooksImport();
                    }
                },{
                    text: 'Cancel',
                    role: 'cancel'
                }
            ]
        });
        actionSheet.present();
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getFirstLabel(rodeoEvent) {
        switch (rodeoEvent.eventType) {
            case 'TeamRoping':
                return 'Header';
            default:
                return 'Rider';            
        }
    }

    getSecondDisplay(rodeoEvent, run : RodeoEventRun) {
        switch (rodeoEvent.eventType) {
            case 'BarrelRacing':
                if (run.horseOne == null)
                    return "Horse 1";
                else
                    return run.horseOne.name;            
            default:
                if (run.livestock == null)
                    return "Livestock 1";
                else
                    return run.livestock.brand + ' ' + run.livestock.name;   
        }
    }

    getSecondLabel(rodeoEvent) {
        switch (rodeoEvent.eventType) {
            case 'BarrelRacing':
                return 'Horse';            
            default:
                return "Livestock";
        }
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(ResultsReport, {
            rodeo: this.rodeo,
            selectedRodeoEvent: this.selectedRodeoEvent,
            winnersOnly: this.winnersOnly,
            printing: true,
            showContactInfo: this.showContactInfo
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-results.ts